// Fundament — site scripts

document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Smooth scrolling (Lenis) ----------
       Native scrolling stays the source of truth (scroll events keep firing for the
       smart header); skipped entirely for users who prefer reduced motion. */
    var lenis = null;
    if (typeof Lenis !== 'undefined' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        lenis = new Lenis({ autoRaf: true });

        // Same-page anchors glide through Lenis instead of jumping.
        document.querySelectorAll('a[href^="#"]').forEach(function (a) {
            a.addEventListener('click', function (e) {
                var id = a.getAttribute('href');
                if (id.length > 1 && document.querySelector(id)) {
                    e.preventDefault();
                    lenis.scrollTo(id, { offset: -96 });   // clear the sticky header
                }
            });
        });
    }

    /* ---------- Mobile navigation ---------- */
    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('.site-header__burger');
    const mobileNav = document.querySelector('.mobile-nav');
    const closeBtn = document.querySelector('.mobile-nav__close');

    function openNav() {
        mobileNav && mobileNav.classList.add('is-open');
        header && header.classList.add('is-open');
        toggle && toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        lenis && lenis.stop();
    }
    function closeNav() {
        mobileNav && mobileNav.classList.remove('is-open');
        header && header.classList.remove('is-open');
        toggle && toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        lenis && lenis.start();
    }

    if (toggle) {
        toggle.addEventListener('click', function () {
            mobileNav && mobileNav.classList.contains('is-open') ? closeNav() : openNav();
        });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (mobileNav) {
        mobileNav.addEventListener('click', function (e) {
            if (e.target === mobileNav) closeNav();
        });
    }

    /* ---------- Header: hide on scroll-down, reveal on scroll-up (mobile) ----------
       Toggles `.is-hidden`; the slide is only applied at mobile widths via CSS. */
    if (header) {
        var lastY = window.scrollY;
        var ticking = false;
        function onHeaderScroll() {
            var y = window.scrollY;
            if (y <= 80 || y < lastY) {
                header.classList.remove('is-hidden');           // near top or scrolling up → show
            } else if (y > lastY && !header.classList.contains('is-open')) {
                header.classList.add('is-hidden');              // scrolling down → hide
            }
            lastY = y;
            ticking = false;
        }
        window.addEventListener('scroll', function () {
            if (!ticking) { window.requestAnimationFrame(onHeaderScroll); ticking = true; }
        }, { passive: true });
    }

    /* ---------- Reading progress bar (article detail) ----------
       Fills as you scroll through the page. Only present on single.php. */
    var progressBar = document.querySelector('.reading-progress__bar');
    if (progressBar) {
        var pTicking = false;
        function onProgress() {
            var doc = document.documentElement;
            var max = doc.scrollHeight - window.innerHeight;
            var pct = max > 0 ? window.scrollY / max : 0;
            if (pct < 0) pct = 0; else if (pct > 1) pct = 1;
            progressBar.style.transform = 'scaleX(' + pct + ')';
            pTicking = false;
        }
        window.addEventListener('scroll', function () {
            if (!pTicking) { window.requestAnimationFrame(onProgress); pTicking = true; }
        }, { passive: true });
        window.addEventListener('resize', onProgress, { passive: true });
        onProgress();
    }

    /* ---------- Dark / light mode ---------- */
    (function () {
        var root = document.documentElement;
        var btns = document.querySelectorAll('.site-header__theme-btn');
        var KEY = 'fam-theme';

        function apply(theme) {
            if (theme === 'dark') root.setAttribute('data-theme', 'dark');
            else root.removeAttribute('data-theme');
            btns.forEach(function (b) {
                b.classList.toggle('is-active', b.dataset.theme === theme);
            });
        }

        // Sync the buttons with whatever the inline <head> script already applied.
        apply(root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');

        var transTimer;
        btns.forEach(function (b) {
            b.addEventListener('click', function () {
                var theme = b.dataset.theme;
                // Enable colour transitions just for the duration of the switch.
                root.classList.add('theme-transition');
                window.clearTimeout(transTimer);
                transTimer = window.setTimeout(function () {
                    root.classList.remove('theme-transition');
                }, 450);
                apply(theme);
                try { localStorage.setItem(KEY, theme); } catch (e) {}
            });
        });
    })();

    /* ---------- News grid: complete rows for the current column count ----------
       The server hides everything beyond the first 9 (three 3-column rows); the
       "bekijk alle berichten" button links to the archive page. Phones show fewer
       (6, per the mobile design); fillRows() tops the visible count up to whole rows
       for the CURRENT column count (e.g. 4-col screens show 12), on load and resize. */
    document.querySelectorAll('.news-grid').forEach(function (grid) {
        var list = grid.querySelector('.news-grid__grid');
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.news-card'));
        var filters = Array.prototype.slice.call(grid.querySelectorAll('.news-grid__filter'));
        var moreBtn = grid.querySelector('.news-grid__more');
        var desktopBatch = parseInt(grid.dataset.batch, 10) || 9;
        var mobileBatch = parseInt(grid.dataset.mobile, 10) || 6;
        var activeCat = 'all';

        function cols() {
            return getComputedStyle(list).gridTemplateColumns.split(' ').length || 1;
        }
        function wholeRowCap(base) {
            var c = cols(), rem = base % c;
            return rem ? base + (c - rem) : base;
        }

        // "Alles" baseline — show the first N as whole rows for the column count, hide the
        // rest behind the "bekijk alle berichten" (archive) button.
        function showAll() {
            cards.forEach(function (card) { card.classList.remove('is-filtered'); });
            var cap = wholeRowCap(cols() === 1 ? mobileBatch : desktopBatch);
            cards.forEach(function (card, i) { card.classList.toggle('is-hidden', i >= cap); });
            if (moreBtn) moreBtn.style.display = cards.length > cap ? '' : 'none';
        }
        // Resize: only top the visible count up to whole rows (one-way, never re-hides).
        function topUp() {
            if (activeCat !== 'all') return;
            var c = cols();
            var visible = cards.filter(function (card) { return !card.classList.contains('is-hidden'); }).length;
            var rem = visible % c;
            if (!rem) return;
            var hidden = cards.filter(function (card) { return card.classList.contains('is-hidden'); });
            for (var i = 0; i < Math.min(c - rem, hidden.length); i++) hidden[i].classList.remove('is-hidden');
        }
        // A category — show every matching card (uncapped), hide the rest + the archive button.
        function showCategory(slug) {
            cards.forEach(function (card) {
                var match = (card.dataset.cats || '').split(' ').indexOf(slug) !== -1;
                card.classList.toggle('is-filtered', !match);
                card.classList.remove('is-hidden');
            });
            if (moreBtn) moreBtn.style.display = 'none';
        }

        filters.forEach(function (btn) {
            btn.addEventListener('click', function () {
                filters.forEach(function (b) { b.classList.remove('is-active'); });
                btn.classList.add('is-active');
                activeCat = btn.dataset.cat || 'all';
                if (activeCat === 'all') showAll(); else showCategory(activeCat);
            });
        });

        showAll();
        window.addEventListener('resize', topUp);
    });

    /* ---------- Article share: copy link ---------- */
    document.querySelectorAll('.post-detail__copy').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var url = btn.dataset.url || window.location.href;
            function done() {
                btn.classList.add('is-copied');
                window.setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
            }
            function fallback() {
                var tmp = document.createElement('input');
                tmp.value = url;
                document.body.appendChild(tmp);
                tmp.select();
                document.execCommand('copy');
                document.body.removeChild(tmp);
                done();
            }
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(done, fallback);
            } else {
                fallback();
            }
        });
    });

    /* ---------- Hero search button → open the TalkWithData chat widget ----------
       The "Benieuwd naar iets?" pill opens the bottom-right chat. The widget script is
       async (footer), so we resolve its API at click time and fall back to clicking its
       own launcher bubble if it hasn't booted yet.

       On desktop the window is then anchored just above the hero pill: it sits in the gap
       between the header and the button when that fits (taller screens), otherwise it's
       clamped to stay on-screen (effectively nudged down, overlapping the pill). Moving the
       widget container also moves the closed-state bubble, so we reset the inline position
       when the chat is closed — the bubble returns to its default bottom-right corner. */
    var chatCloseObserver = null;

    function resetChatPosition() {
        var c = document.querySelector('.superdock-widget-container');
        if (c) { c.style.top = c.style.left = c.style.right = c.style.bottom = ''; }
    }

    function watchChatClose() {
        if (chatCloseObserver || !window.MutationObserver) return;
        var win = document.querySelector('.superdock-chat-window');
        if (!win) return;
        chatCloseObserver = new MutationObserver(function () {
            if (win.classList.contains('superdock-hidden')) resetChatPosition();
        });
        chatCloseObserver.observe(win, { attributes: true, attributeFilter: ['class'] });
    }

    function positionChatAboveHero(btn) {
        if (window.innerWidth < 768) return;   // mobile: let the widget use its own layout
        var c = document.querySelector('.superdock-widget-container');
        if (!c) return;
        var gap = 16;
        var br = btn.getBoundingClientRect();
        var winW = c.offsetWidth || 380;
        var winH = c.offsetHeight || 600;
        var header = document.querySelector('.site-header');
        var minTop = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 96) + gap;

        var top = br.top - gap - winH;                          // ideal: bottom just above the pill
        top = Math.max(top, minTop);                            // never cross above the header/hero top
        top = Math.min(top, window.innerHeight - winH - gap);   // never run off the bottom
        top = Math.max(top, gap);
        var left = br.left + br.width / 2 - winW / 2;           // centred over the pill
        left = Math.min(Math.max(left, gap), window.innerWidth - winW - gap);

        c.style.top = top + 'px';
        c.style.left = left + 'px';
        c.style.right = 'auto';
        c.style.bottom = 'auto';
    }

    function openChatWidget() {
        var twd = window.TalkWithDataWidget || window.SuperdockWidget;
        if (twd && typeof twd.open === 'function') {
            twd.open();
            return true;
        }
        var bubble = document.querySelector('.superdock-chat-bubble');
        if (bubble) {
            bubble.click();
            return true;
        }
        return false;
    }

    document.querySelectorAll('.hero__search').forEach(function (btn) {
        btn.addEventListener('click', function () {
            openChatWidget();
            // Position after the window has rendered so its size is known.
            requestAnimationFrame(function () {
                positionChatAboveHero(btn);
                watchChatClose();
            });
        });
    });

    /* The footer e-mail address opens the chat too (same action as the hero pill), in
       the widget's default bottom-right spot — any hero-anchored inline position is
       cleared first. The mailto: href stays as the fallback when the widget hasn't
       booted (openChatWidget returns false and the default isn't prevented). */
    document.querySelectorAll('.site-footer__email').forEach(function (link) {
        link.addEventListener('click', function (e) {
            resetChatPosition();
            if (openChatWidget()) {
                e.preventDefault();
                requestAnimationFrame(watchChatClose);
            }
        });
    });

    /* ---------- Gravity Forms: floating labels (newsletter + contact) ----------
       GF renders the label before the input, so CSS sibling selectors can't float it;
       these classes drive the same animation as the static fallback form. */
    document.querySelectorAll('.newsletter .gfield, .contact-form .gfield').forEach(function (field) {
        var input = field.querySelector('input:not([type="hidden"]), textarea');
        if (!input) return;
        function sync() {
            field.classList.toggle('is-focused', document.activeElement === input);
            field.classList.toggle('has-value', input.value !== '');
        }
        input.addEventListener('focus', sync);
        input.addEventListener('blur', sync);
        input.addEventListener('input', sync);
        sync();
    });

    /* ---------- Cases slider (Swiper) ---------- */
    if (typeof Swiper !== 'undefined') {
        document.querySelectorAll('.cases__slider').forEach(function (el) {
            // Autoplay is an editor toggle on the section (data-autoplay, see
            // cases-section.php); never auto-advance for reduced-motion users.
            var autoplay = el.hasAttribute('data-autoplay')
                && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            new Swiper(el, {
                slidesPerView: 1,
                spaceBetween: 32,
                loop: el.querySelectorAll('.swiper-slide').length > 1,
                autoplay: autoplay ? { delay: 5000, pauseOnMouseEnter: true, disableOnInteraction: false } : false,
                pagination: {
                    el: el.querySelector('.cases__pagination'),
                    clickable: true,
                },
            });
        });
    }

    /* ---------- Lazy autoplay videos ----------
       Case/news videos carry data-autoplay-visible instead of the autoplay attribute:
       with preload="metadata" only a sliver downloads up front (the poster covers the
       box), and playback — and therefore streaming — starts when the video scrolls
       into view and pauses when it leaves. Keeps /ons-werk/ from pulling every case
       video (100MB+) on page load. Runs AFTER the Swiper init so the slider's cloned
       slides are observed too. Reduced-motion users just get the poster. */
    var lazyVideos = document.querySelectorAll('video[data-autoplay-visible]');
    if (lazyVideos.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var playVideo = function (v) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } };
        if ('IntersectionObserver' in window) {
            var videoObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        playVideo(entry.target);
                    } else if (!entry.target.paused) {
                        entry.target.pause();
                    }
                });
            }, { rootMargin: '100px 0px', threshold: 0.1 });
            lazyVideos.forEach(function (v) { videoObserver.observe(v); });
        } else {
            lazyVideos.forEach(playVideo);
        }
    }
});
